import { render, staticRenderFns } from "./sppt.vue?vue&type=template&id=d10542ec&"
import script from "./sppt.vue?vue&type=script&lang=js&"
export * from "./sppt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports